const WHITE_LABEL_IMPERSONATE = 'WHITELABEL';
const DEALER_NETWORK_IMPERSONATE = 'DEALER_NETWORK';
const DEFAULT_IMPERSONATE = 'DEFAULT';

const isDealerNetworkResolverType = urlResolverType => {
  return urlResolverType === DEALER_NETWORK_IMPERSONATE;
};

const isWhiteLabelResolverType = urlResolverType => {
  return urlResolverType === WHITE_LABEL_IMPERSONATE;
};

const isDefaultResolverType = urlResolverType => {
  return urlResolverType === DEFAULT_IMPERSONATE;
};

export {
  WHITE_LABEL_IMPERSONATE,
  DEFAULT_IMPERSONATE,
  DEALER_NETWORK_IMPERSONATE,
  isDealerNetworkResolverType,
  isDefaultResolverType,
  isWhiteLabelResolverType
};
